module.exports = __webpack_public_path__ + "img/Login_Dot_inActive.58145c70.svg";